import { TextField } from '@mui/material';
import type { PromotionInput } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';
import { get } from 'lodash';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useFormErrorNotificationContext } from '../../../../../../../contexts/form-error-notification-context/form-error-notification-context';
import { handleNumericTextFieldChange } from '../../../../../../../services/form-utils';
import { useChargeContext } from '../../../charge-context';
import type { PlanInputForm } from '../../../CreatePlanForm/create-plan-form-types/plan-input-form';
import type { CreatePlanTab } from '../../../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { CREATE_PLAN_TABS } from '../../../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { ChargeEditDrawerContentContainer } from '../../../FixedChargeEditDrawer/fixed-charge-edit-drawer-components/ChargeEditDrawerContentContainer';
import { ChargeEditDrawerContentItemOptional } from '../../../FixedChargeEditDrawer/fixed-charge-edit-drawer-components/ChargeEditDrawerContentItemOptional';
import { ChargeEditDrawerContentSection } from '../../../FixedChargeEditDrawer/fixed-charge-edit-drawer-components/ChargeEditDrawerContentSection';

export const PercentageChargeEditDrawerContent: React.FC = () => {
  const { itemIndex: promotionIndex } = useChargeContext<PromotionInput>();
  const { registerErrorField } = useFormErrorNotificationContext<PlanInputForm, CreatePlanTab>();
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext<PlanInputForm>();

  const registerDescription = register(`promotionProducts.${promotionIndex}.description`);
  const registerInstallments = register(
    `promotionProducts.${promotionIndex}.variants.0.pricing.priceConfiguration.installments`,
  );

  registerErrorField(registerDescription.name, CREATE_PLAN_TABS.promotions);
  registerErrorField(registerInstallments.name, CREATE_PLAN_TABS.promotions);

  return (
    <ChargeEditDrawerContentContainer>
      <ChargeEditDrawerContentSection title="Pricing Settings">
        <ChargeEditDrawerContentItemOptional fieldPath={registerDescription.name} label="Add description">
          <Controller
            control={control}
            name={registerDescription.name}
            render={({ field }) => (
              <TextField
                value={field.value}
                onChange={field.onChange}
                fullWidth
                placeholder="Add description"
                size="medium"
                error={isNotNullOrUndefined(get(errors, field.name))}
              />
            )}
          />
        </ChargeEditDrawerContentItemOptional>

        <ChargeEditDrawerContentItemOptional
          fieldPath={`promotionProducts.${promotionIndex}.variants.0.pricing.priceConfiguration.installments`}
          label="Recurring discount"
        >
          <Controller
            control={control}
            name={`promotionProducts.${promotionIndex}.variants.0.pricing.priceConfiguration.installments`}
            render={({ field }) => (
              <TextField
                value={field.value}
                onChange={handleNumericTextFieldChange(field.onChange)}
                fullWidth
                placeholder="0"
                size="medium"
                type="number"
                error={isNotNullOrUndefined(get(errors, field.name))}
              />
            )}
          />
        </ChargeEditDrawerContentItemOptional>
      </ChargeEditDrawerContentSection>
    </ChargeEditDrawerContentContainer>
  );
};
